export const APPLICATION_READY_SUCCESS = 'PREDEFINED_MESSAGES/DETAILS/APPLICATION_READY_SUCCESS';
export const APPLICATION_READY_FAILURE = 'PREDEFINED_MESSAGES/DETAILS/APPLICATION_READY_FAILURE';

export const FETCH_PREDEFINED_MESSAGE = 'PREDEFINED_MESSAGES/FETCH/FETCH_PREDEFINED_MESSAGE_REQUEST';
export const FETCH_PREDEFINED_MESSAGE_SUCCESS = 'PREDEFINED_MESSAGES/FETCH/FETCH_PREDEFINED_MESSAGE_SUCCESS';
export const FETCH_PREDEFINED_MESSAGE_FAILURE = 'PREDEFINED_MESSAGES/FETCH/FETCH_PREDEFINED_MESSAGE_FAILURE';

export const FETCH_PREDEFINED_MESSAGES = 'PREDEFINED_MESSAGES/FETCH/FETCH_PREDEFINED_MESSAGES_REQUEST';
export const FETCH_PREDEFINED_MESSAGES_SUCCESS = 'PREDEFINED_MESSAGES/FETCH/FETCH_PREDEFINED_MESSAGES_SUCCESS';
export const FETCH_PREDEFINED_MESSAGES_FAILURE = 'PREDEFINED_MESSAGES/FETCH/FETCH_PREDEFINED_MESSAGES_FAILURE';

export const FETCH_ALL_BY_DEALER = 'PREDEFINED_MESSAGES/FETCH/DEALER/REQUEST';
export const FETCH_ALL_BY_DEALER_SUCCESS = 'PREDEFINED_MESSAGES/FETCH/DEALER/SUCCESS';
export const FETCH_ALL_BY_DEALER_FAILURE = 'PREDEFINED_MESSAGES/FETCH/DEALER/FAILURE';

export const FETCH_FIND_DEALER_OR_GROUP = 'PREDEFINED_MESSAGES/FETCH/FIND_DEALER_OR_GROUP_REQUEST';
export const FETCH_FIND_DEALER_OR_GROUP_SUCCESS = 'PREDEFINED_MESSAGES/FETCH/FIND_DEALER_OR_GROUP_SUCCESS';
export const FETCH_FIND_DEALER_OR_GROUP_FAILURE = 'PREDEFINED_MESSAGES/FETCH/FIND_DEALER_OR_GROUP_FAILURE';

export const CREATE = 'PREDEFINED_MESSAGES/POST/CREATE_REQUEST';
export const CREATE_SUCCESS = 'PREDEFINED_MESSAGES/POST/CREATE_SUCCESS';
export const CREATE_FAILURE = 'PREDEFINED_MESSAGES/POST/CREATE_FAILURE';

export const UPDATE = 'PREDEFINED_MESSAGES/PUT/UPDATE_REQUEST';
export const UPDATE_SUCCESS = 'PREDEFINED_MESSAGES/PUT/UPDATE_SUCCESS';
export const UPDATE_FAILURE = 'PREDEFINED_MESSAGES/PUT/UPDATE_FAILURE';

export const DELETE = 'PREDEFINED_MESSAGES/DELETE/DELETE_REQUEST';
export const DELETE_SUCCESS = 'PREDEFINED_MESSAGES/DELETE/DELETE_SUCCESS';
export const DELETE_FAILURE = 'PREDEFINED_MESSAGES/DELETE/DELETE_FAILURE';

export const CLONE = 'PREDEFINED_MESSAGES/CLONE/CLONE_REQUEST';
export const CLONE_FAILURE = 'PREDEFINED_MESSAGES/CLONE/CLONE_FAILURE';
export const CLONE_SUCCESS = 'PREDEFINED_MESSAGES/CLONE/CLONE_SUCCESS';

export const SELECT_ID = 'PREDEFINED_MESSAGES/DETAILS/SELECT_ID';
export const SELECT_LANGUAGE = 'PREDEFINED_MESSAGES/DETAILS/SELECT_LANGUAGE';
export const SET_LANGUAGES = 'PREDEFINED_MESSAGES/DETAILS/SET_LANGUAGES';

export const REFRESH_DASHBOARD = 'PREDEFINED_MESSAGES/DASHBOARD/REFRESH';
export const SET_DASHBOARD_FILTERS = 'PREDEFINED_MESSAGES/DASHBOARD/SET_FILTERS';
export const REMOVE_DASHBOARD_FILTERS = 'PREDEFINED_MESSAGES/DASHBOARD/REMOVE_FILTERS';

export const OPEN_DUPLICATE_MODAL = 'PREDEFINED_MESSAGES/DUPLICATE/OPEN_DUPLICATE';
export const CLOSE_DUPLICATE_MODAL = 'PREDEFINED_MESSAGES/DUPLICATE/CLOSE_DUPLICATE';

export const TRANSLATIONS_PAGE_READY = 'PREDEFINED_MESSAGES/TRANSLATIONS/PAGE_READY';
